// packages/ag-charts-locale/src/de-DE.ts
var AG_CHARTS_LOCALE_DE_DE = {
  ariaAnnounceChart: "Diagramm, ${seriesCount}[number] Reihen",
  ariaAnnounceFlowProportionLink: "Link ${index} von ${count}, von ${from} bis ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "Knoten ${index} von ${count}, ${description}",
  ariaAnnounceGaugeChart: "Tachometerdiagramm, ${caption}",
  ariaAnnounceHierarchyChart: "Hierarchiediagramm, ${caption}",
  ariaAnnounceHierarchyDatum: "Ebene ${level}[number], ${count}[number] Kinder, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Dr\xFCcken Sie die Leertaste oder die Eingabetaste, um die Sichtbarkeit umzuschalten",
  ariaLabelAddHorizontalLine: "Horizontale Linie hinzuf\xFCgen",
  ariaLabelAnnotationOptionsToolbar: "Anmerkungsoptionen",
  ariaLabelAnnotationSettingsDialog: "Annotationseinstellungen",
  ariaLabelColorPicker: "Farbw\xE4hler",
  ariaLabelFinancialCharts: "Finanzdiagramme",
  ariaLabelLegend: "Legende",
  ariaLabelLegendItem: "${label}, Legendenpunkt ${index}[number] von ${count}[number]",
  ariaLabelLegendItemUnknown: "Unbekanntes Legenden Element",
  ariaLabelLegendPageNext: "N\xE4chste Legenden-Seite",
  ariaLabelLegendPagePrevious: "Vorherige Legenden-Seite",
  ariaLabelLegendPagination: "Legenden-Seitenumbruch",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Mindestwert",
  ariaLabelNavigatorRange: "Bereich",
  ariaLabelRangesToolbar: "Bereiche",
  ariaLabelSettingsTabBar: "Einstellungen",
  ariaLabelZoomToolbar: "Vergr\xF6\xDFern",
  ariaValuePanRange: "${min}[percent0to2dp] bis ${max}[percent0to2dp]",
  contextMenuDownload: "Herunterladen",
  contextMenuPanToCursor: "Hierher schwenken",
  contextMenuToggleOtherSeries: "Andere Serien umschalten",
  contextMenuToggleSeriesVisibility: "Sichtbarkeit umschalten",
  contextMenuZoomToCursor: "Hierher zoomen",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Datum und Preis",
  dialogHeaderDateRange: "Datumsbereich",
  dialogHeaderFibonacciRange: "Fib R\xFCcksetzung",
  dialogHeaderLine: "Linie",
  dialogHeaderPriceRange: "Preisspanne",
  dialogHeaderText: "Text",
  dialogInputAlign: "Ausrichten",
  dialogInputColorPicker: "Farbe",
  dialogInputColorPickerAltText: "Textfarbe",
  dialogInputExtendAbove: "Nach oben erweitern",
  dialogInputExtendBelow: "Nach unten erweitern",
  dialogInputExtendChannelEnd: "Kanalende erweitern",
  dialogInputExtendChannelStart: "Kanalanfang erweitern",
  dialogInputExtendLeft: "Nach links erweitern",
  dialogInputExtendLineEnd: "Linienende verl\xE4ngern",
  dialogInputExtendLineStart: "Linienanfang verl\xE4ngern",
  dialogInputExtendRight: "Nach rechts verl\xE4ngern",
  dialogInputFibonacciBands: "B\xE4nder",
  dialogInputFibonacciBandsAltText: "Fibonacci-B\xE4nder",
  dialogInputFillColorPicker: "F\xFCllen",
  dialogInputFillColorPickerAltText: "F\xFCllfarbe",
  dialogInputFontSize: "Gr\xF6\xDFe",
  dialogInputFontSizeAltText: "Schriftgr\xF6\xDFe",
  dialogInputLineStyle: "Gestrichelt",
  dialogInputPosition: "Position",
  dialogInputReverse: "Umkehren",
  dialogInputShowFill: "F\xFCllung anzeigen",
  dialogInputStrokeWidth: "Linienbreite",
  dialogInputStrokeWidthAltText: "Linienst\xE4rke",
  iconAltTextAlignCenter: "Zentrum",
  iconAltTextAlignLeft: "Links",
  iconAltTextAlignRight: "Rechts",
  iconAltTextClose: "Schlie\xDFen",
  iconAltTextLineStyleDashed: "Lang gestrichelt",
  iconAltTextLineStyleDotted: "Kurz gestrichelt",
  iconAltTextLineStyleSolid: "Durchgezogen",
  iconAltTextPositionBottom: "Unten",
  iconAltTextPositionCenter: "Mitte",
  iconAltTextPositionTop: "Oben",
  inputTextareaPlaceholder: "Text hinzuf\xFCgen",
  measurerDateRangeBars: "${value}[number] Balken",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volumen ${value}",
  overlayLoadingData: "Daten werden geladen...",
  overlayNoData: "Keine Daten zum Anzeigen",
  overlayNoVisibleSeries: "Keine sichtbaren Serien",
  overlayUnsupportedBrowser: "Inkompatible Browserversion. Bitte aktualisieren Sie Ihren Browser.",
  seriesHistogramTooltipCount: "${yName} (Anzahl)",
  seriesHistogramTooltipFrequency: "H\xE4ufigkeit",
  seriesHistogramTooltipMean: "${yName} (Mittelwert)",
  seriesHistogramTooltipSum: "${yName} (Summe)",
  toolbarAnnotationsArrow: "Pfeil",
  toolbarAnnotationsArrowDown: "Pfeil nach unten",
  toolbarAnnotationsArrowUp: "Pfeil nach oben",
  toolbarAnnotationsCallout: "Hinweis",
  toolbarAnnotationsClearAll: "Alles l\xF6schen",
  toolbarAnnotationsComment: "Kommentar",
  toolbarAnnotationsDatePriceRange: "Datum und Preis",
  toolbarAnnotationsDateRange: "Datumsbereich",
  toolbarAnnotationsDelete: "L\xF6schen",
  toolbarAnnotationsDisjointChannel: "Getrennter Kanal",
  toolbarAnnotationsDragHandle: "Werkzeugleiste ziehen",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib-Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib retracement basierend auf Trend",
  toolbarAnnotationsFillColor: "F\xFCllfarbe",
  toolbarAnnotationsHorizontalLine: "Horizontale Linie",
  toolbarAnnotationsLineAnnotations: "Trendlinien",
  toolbarAnnotationsLineColor: "Linienfarbe",
  toolbarAnnotationsLineStrokeWidth: "Linienstrichbreite",
  toolbarAnnotationsLineStyle: "Linienstil",
  toolbarAnnotationsLock: "Sperren",
  toolbarAnnotationsMeasurerAnnotations: "Messger\xE4te",
  toolbarAnnotationsNote: "Hinweis",
  toolbarAnnotationsParallelChannel: "Paralleler Kanal",
  toolbarAnnotationsPriceRange: "Preisspanne",
  toolbarAnnotationsQuickDatePriceRange: "Messen",
  toolbarAnnotationsSettings: "Einstellungen",
  toolbarAnnotationsShapeAnnotations: "Pfeile",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textanmerkungen",
  toolbarAnnotationsTextColor: "Textfarbe",
  toolbarAnnotationsTextSize: "Textgr\xF6\xDFe",
  toolbarAnnotationsTrendLine: "Trendlinie",
  toolbarAnnotationsUnlock: "Freischalten",
  toolbarAnnotationsVerticalLine: "Vertikale Linie",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 Monat",
  toolbarRange1Year: "1J",
  toolbarRange1YearAria: "1 Jahr",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 Monate",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 Monate",
  toolbarRangeAll: "Alle",
  toolbarRangeAllAria: "Alle",
  toolbarRangeYearToDate: "Seit Jahresbeginn",
  toolbarRangeYearToDateAria: "Jahr bis Datum",
  toolbarSeriesTypeCandles: "Kerzen",
  toolbarSeriesTypeDropdown: "Diagrammtyp",
  toolbarSeriesTypeHighLow: "Hoch Tief",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hohle Kerzen",
  toolbarSeriesTypeLine: "Linie",
  toolbarSeriesTypeLineWithMarkers: "Linie mit Markierungen",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Stufenlinie",
  toolbarZoomPanEnd: "Zum Ende verschieben",
  toolbarZoomPanLeft: "Nach links verschieben",
  toolbarZoomPanRight: "Nach rechts schwenken",
  toolbarZoomPanStart: "Zum Anfang schwenken",
  toolbarZoomReset: "Zoom zur\xFCcksetzen",
  toolbarZoomZoomIn: "Vergr\xF6\xDFern",
  toolbarZoomZoomOut: "Verkleinern",
  tooltipPaginationStatus: "${index}[number] von ${count}[number]"
};
export {
  AG_CHARTS_LOCALE_DE_DE
};
//# sourceMappingURL=de-DE.esm.mjs.map
